import { ApolloError, useMutation } from '@apollo/client';
import { IProductReviewCreatePayload } from '@monofront/types';
import { CREATE_PRODUCT_REVIEW } from '../../queries/productReview';

interface IUseProductReviewReturn {
  error: ApolloError | undefined;
  called: boolean;
  isLoading: boolean;
  createProductReview: (payload: IProductReviewCreatePayload) => void;
}

export const useCreateProductReview = (): IUseProductReviewReturn => {
  const [createReview, { called, loading, error }] = useMutation(
    CREATE_PRODUCT_REVIEW,
    {
      // prevent graphql error message panel display. to handle error, use called and error above in component
      onError: (error) => {
        console.error(error);
      },
    },
  );

  const createProductReview = (payload: IProductReviewCreatePayload): void => {
    createReview({
      variables: {
        ...payload,
      },
    });
  };

  return {
    error,
    isLoading: loading,
    called,
    createProductReview,
  };
};
